<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12" md="7" lg="5" id="login-form" class="p-3 p-lg-4 p-xl-5">
        <b-row>
          <b-col cols="12" md="4" class="text-center text-lg-left py-3" align-self="center">
            <img :src="$store.getters.universe.logoLogin" :alt="$store.getters.universe.siteName" style="height: 100%; max-height: 50px; width: auto; max-width: 150px;">
          </b-col>
        </b-row>

        <b-row class="py-3">
          <b-col class="text-center text-md-left">
            <h2 v-translate>Reset your password</h2>
            <br>
            <form @submit.prevent="send()" class="form form--login grid" v-show="sent === false">
              <p v-translate>Please fill the form fields</p>
              <div class="row">
                <div class="form-group col-md-12">
                  <password ref="pwd_check" :min="passwordMinLength" :placeholder="$gettext('New Password')" v-model="password" inputClass="form-control" @input="validatePassword" @score="newPasswordScore = $event" :min-score="passwordMinScore" />
                  <b-form-text id="inputLiveHelp" v-translate="{minLength: passwordMinLength}">%{minLength} characters minimum, must contain upper and lower case letters, numbers and symbols</b-form-text>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                    <b-form-input aria-describedby="inputLiveHelp inputLiveFeedback" :placeholder="$gettext('Repeat New Password')" :state="samePassword" type="password" v-model="passwordConfirm" @input="validatePassword" autocomplete="new-password" required></b-form-input>
                    <b-form-invalid-feedback id="inputLiveFeedback" v-translate>Passwords don't match</b-form-invalid-feedback>
                </div>
              </div>
              <br>
              <b-row>
                <b-col cols="12" class="text-center text-md-right">
                  <button type="submit" class="btn btn-lg btn-primary" :disabled="!samePassword || password.length < passwordMinLength || newPasswordScore < passwordMinScore"><strong v-translate>Reset password</strong></button>
                </b-col>
              </b-row>
            </form>
            <b-alert variant="success" show v-show="sent === true"><translate>The password has been reset. Now you can</translate> <router-link :to="{name: 'login'}"><strong v-translate>log in</strong></router-link> <translate>with the new password.</translate></b-alert>
            <br>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" md="5" lg="7" id="login-bg" :class="'d-none d-md-block ' + $store.getters.universe.bgLogin || ''" :style="$store.getters.universe?.bgImgLogin ? 'background-image: url(' + $store.getters.universe.bgImgLogin + ')' : ''">

      </b-col>
    </b-row>

    <span class="d-none" v-translate>New Password</span>
    <span class="d-none" v-translate>Repeat New Password</span>
  </b-container>
</template>

<script>
  import ApiService from '@/common/api.service'
  import Password from '@/components/Password'

  export default {
    name: 'PasswordResetPage',
    title() {
      return this.$gettext('Reset your password')
    },
    components: {
      Password
    },
    data () {
      return {
        email: this.$route.query.email,
        password: '',
        passwordConfirm: '',
        token: this.$route.params.token,
        sent: false,
        samePassword: null,
        passwordMinLength: 12,
        passwordMinScore: 100,
        newPasswordScore: 0
      }
    },
    methods: {
      validatePassword () {
        this.samePassword = this.password.length > 0 ? this.password === this.passwordConfirm : null
      },
      send () {
        if (this.email !== '') {
          console.log({email: this.email, password: this.password, password_confirmation: this.passwordConfirm, token: this.token})
          ApiService.post('password/reset', {email: this.email, password: this.password, password_confirmation: this.passwordConfirm, token: this.token})
            .then(response => {
              this.sent = true
              console.log(response)
            })
            .catch(e => {
              console.log(e)
            })
        }
      }
    }
  }
</script>
